import { isArray } from 'lodash';

/**
 * @description Return the price(step price if applicable) of plan
 * @param {number} quantity the quantity of plan in shopping cart
 * @param {number} originalPrice the amount from subscription API
 * @param {object} planMapInfo the plan info in planMapFlat
 * @returns {number} the price (step price if applicable)
 */
export function getPriceByQuantity(quantity, originalPrice, planMapInfo) {
    const { prices, isStepPrice } = planMapInfo;
    const isValidStepPriceCase = isStepPrice === true && isArray(prices);
    let resultPrice = originalPrice;
    if (isValidStepPriceCase) {
      const matchedPriceRange = prices.find(({ start, end}) => quantity >= start && quantity <= end);
      console.assert(matchedPriceRange, 'can not match price', quantity, prices);
      if (matchedPriceRange) {
        const stepPrice = matchedPriceRange.price;
        // TODO: Custom Price + Step Price handler
        // resultPrice = math.min(stepPrice, originalPrice);
        resultPrice = stepPrice;
      }
    }
    return resultPrice;
  }